import { useState } from 'react';
import CommonTabContent from '../../../components/common-tab-content';
const options = ['Explain SQL Query', 'Highlight agent actions'];
interface PromptText {
	[key: number]: string;
}
const promptText: PromptText = {
	0: 'Explain the given SQL query in a clear, concise manner.',
	1: "From the given content, list concrete steps taken by the service agent to solve the user's problem. Do not include introductions, requests for information, or transfers. Provide output in markdown format.",
};

const ExplainTabContent: React.FC = () => {
	const [promptValue, setPromptValue] = useState<string>(promptText[0]);

	const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedOptionIndex = parseInt(e.target.value);
		setPromptValue(promptText[selectedOptionIndex]);
	};
	return (
		<div className="max-w-2xl">
			<div className="mb-4">
				<select
					className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-gray-600 sm:text-sm sm:leading-6"
					onChange={handleSelectChange}
				>
					{options.map((item, index) => (
						<option key={index} value={index}>
							{item}
						</option>
					))}
				</select>
			</div>
			<CommonTabContent defaultPrompt={promptValue} />
		</div>
	);
};

export default ExplainTabContent;
